import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import { FormAction } from 'core/store/offer-store/offer-store';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { Tooltip } from 'core/components/tooltip';
import { withToast } from 'core/components/toast';
import { useStore } from 'core/store/store.mobx';
import useSession from 'core/hooks/use-session';
import useStyles from '../footer.styles';
import { ConfirmCheckout } from '../../checkout';

const UWForm = observer(({ showValidationErrorsModal, onContinueToUWForm }) => {
  const { offer: store } = useStore();
  const classes = useStyles();
  const { validateForm } = useFormikContext();
  const { canEditOffers } = useSession();

  useEffect(() => {
    store.setFormAction({ action: FormAction.PreBindUWValidation });
  }, []);

  return (
    <>
      <div>
        <Label className={classes.title} type="subtitle">
          We'll ask a few quick questions about the home
        </Label>
        <Label className={classes.subtitle} type="subtitle">
          This helps confirm that the home meets eligibility requirements. It only takes a few seconds.
        </Label>
      </div>
      <ConfirmCheckout
        onCheckout={onContinueToUWForm}
        showValidationModal={showValidationErrorsModal}
        validateCheckout={validateForm}
        CheckOutAction={({ onClick }) => (
          <Grid container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              className={classes.wideBtn}
              disabled={store.loading || !canEditOffers}
              onClick={onClick}
            >
              <Label className={classes.btnLabel}>Continue to Underwriting Review</Label>
            </Button>
            {!canEditOffers && (
              <Tooltip text="You must have edit access to offers to continue to the underwriting review page" />
            )}
          </Grid>
        )}
      />
    </>
  );
});
export default withToast(UWForm);
